/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '/',
    name: ['Index', 'Index'],
    view: 'Index',
    free: true
  },
  {
    path: '/site',
    redirect: '/login',
    view: 'Index',
    free: true
  },
  {
    path: '/bio',
    view: 'Bio',
    free: true
  },
  {
    path: '/cursos',
    view: 'CursosPremium',
    free: true
  },
  {
    path: '/br',
    view: 'IndexBR',
    free: true
  },
  {
    path: '/en',
    view: 'IndexEN',
    free: true
  },
  {
    path: '/blog',
    redirect: '/login',
    view: 'Index',
    free: true
  },
  {
    path: '/seja-premium',
    name: ['Seja Premium', 'Be Premium'],
    view: 'Premium'

  },
  {
    path: '/user',
    name: ['Usuario', 'User'],
    view: 'User'
  },
  {
    path: '/login',
    name: 'Login',
    view: 'Login',
    free: true
  },
  {
    path: '/ativacao-teste',
    name: 'AtivacaoTeste',
    view: 'AtivacaoTeste',
    free: true
  },
  {
    path: '/signin',
    name: 'SignIn',
    view: 'SignIn',
    free: true
  },
  {
    path: '/dashboard',
    name: ['Dashboard', 'Dashboard'],
    view: 'Dashboard'
  },
  {
    path: '/feedback',
    name: ['Feedback', 'Feedback'],
    view: 'Feedback'
  },
  {
    path: '/ferramentas',
    name: ['Ferramentas', 'Tools', 'Herramientas'],
    view: 'Ferramentas',
    free: true
  },
  {
    path: '/formulacao-dieta',
    name: ['Formulação de Dietas', 'Diet Formulation'],
    view: 'FormulacaoDieta'
  },
  {
    path: '/formulacao-suplemento',
    name: ['Formulação de Suplemento', 'Supplement Formulation', 'Formulación de suplementos'],
    view: 'Suplemento'
  },
  {
    path: '/calcular-racao',
    name: ['Calcular Ração', 'Ration Calculator', 'Calc. Raccíon'],
    view: 'CalcularRacao'
  },
  {
    path: '/plano-confinamento',
    name: ['Plano de Confinamento/Pasto', 'Diet Plan', 'Plano de dieta'],
    view: 'PlanoConfinamento'
  },
  {
    path: '/tabela-resumida',
    name: ['Tabela Resumida', 'Short Feed Composition'],
    view: 'TabelaResumida'
  },
  {
    path: '/predicao-desempenho',
    name: ['Predição de Desempenho', 'Performance Prediction'],
    view: 'PredicaoDesempenho'
  },
  {
    path: '/enviar-alimento',
    name: ['Enviar Alimento', 'Send Feed'],
    view: 'Alimentos'
  },
  {
    path: '/enviar-alimento/custos',
    name: ['Enviar Alimento/CUSTOS', 'Send Feed/COSTS'],
    view: 'Alimentos'
  },
  {
    path: '/enviar-alimento/cqbal',
    name: ['Enviar Alimento/CQBAL', 'Send Feed/CQBAL'],
    view: 'Alimentos'
  },
  {
    path: '/enviar-alimento/privado',
    name: ['Enviar Alimento/Privado', 'Send Feed/Private'],
    view: 'Alimentos'
  },
  {
    path: '/enviar-alimento/adaptar',
    name: ['Enviar Alimento/Adaptar', 'Send Feed/Adapt'],
    view: 'Alimentos'
  },
  
  {
    path: '/enviar-alimento/meus-alimentos',
    name: ['Enviar Alimento/Meus Alimentos', 'Send Feed/My Feeds'],
    view: 'Alimentos'
  },
  {
    path: '/enviar-alimento/tabela-resumida',
    name: ['Enviar Alimento/Tabela Resumida', 'Send Feed/Feeds List'],
    view: 'Alimentos'
  },
  {
    path: '/calcula-exigencias',
    name: ['Calcular Exigências', 'Get Requirements'],
    view: 'CalcularExigencias'
  },
  {
    path: '/consultor',
    name: ['Consultor', 'Consult'],
    view: 'Consultor'
  },
  {
    path: '/empresa',
    name: ['BR-Corte Studio', 'BR-Corte Studio'],
    view: 'StudioRedirect'
  },
  {
    path: '/empresa/clientes',
    name: ['Clientes', 'Clients'],
    view: 'StudioRedirect'
  },
  {
    path: '/empresa/add-colaborador',
    name: ['Add Colaborador', 'Company'],
    view: 'Empresa'
  },
  {
    path: '/empresa/add-contato-emp-tecnico',
    name: ['Add Contato', 'Company'],
    view: 'Empresa'
  },
  {
    path: '/empresa/add-alimento',
    name: ['Add Alimento', 'Company'],
    view: 'Empresa'
  },
  {
    path: '/empresa/relatorios',
    name: ['Relatórios', 'Company'],
    view: 'StudioRedirect'
  },
  {
    path: '/empresa/editar',
    name: ['Editar', 'Company'],
    view: 'Empresa'
  },
  {
    path: '/empresa/alimentos',
    name: ['Empresa Alimentos', 'Company Feeds'],
    view: 'StudioRedirect'
  },
  {
    path: '/empresa/colaboradores',
    name: ['Colaboradores', 'Employers'],
    view: 'Empresa'
  },
  {
    path: '/empresa/parceiros',
    name: ['Parceiros', 'Partners'],
    view: 'Empresa'
  },
  {
    path: '/adm',
    name: ['Administração', 'Admin'],
    view: 'Administracao'
  },
  {
    path: '/adm/notificacoes',
    name: ['Notificaçoes ADM', 'ADM Notifications'],
    view: 'Administracao'
  },
  {
    path: '/adm/solicitacaoPremium',
    name: ['Solicitação de Premium', 'Premium Solicitation'],
    view: 'Administracao'
  },
  {
    path: '/adm/reportes',
    name: ['Reporte de Erro', 'Bug Report'],
    view: 'Administracao'
  },
  {
    path: '/adm/empresaControle',
    name: ['Controle de Empresa', 'Company Control'],
    view: 'Administracao'
  },
  {
    path: '/adm/user/new',
    name: ['Novo User', 'User'],
    view: 'Administracao'
  },
  {
    path: '/adm/user/edit',
    name: ['Edição de User', 'User'],
    view: 'Administracao'
  },
  {
    path: '/adm/user/map',
    name: ['Mapa de User', 'User'],
    view: 'Administracao'
  },
  {
    path: '/adm/empresa/new',
    name: ['Nova Empresa', 'Company'],
    view: 'Administracao'
  },
  {
    path: '/adm/empresa/edit',
    name: ['Editar Empresa', 'Company'],
    view: 'Administracao'
  },
  {
    path: '/adm/vincular-colaborador',
    name: ['Vincular Colaborador', 'Company'],
    view: 'Administracao'
  },
  {
    path: '/adm/ajuda',
    name: ['Gerenciamento de Ajudas', 'Help'],
    view: 'Administracao'
  },
  {
    path: '/adm/relatorio',
    name: ['Relatórios', 'Reports'],
    view: 'Administracao'
  },
  {
    path: '/adm/logs',
    name: ['Logs', 'Logs'],
    view: 'Administracao'
  },
  {
    path: '/adm/dietas',
    name: ['Dietas', 'Diets'],
    view: 'Administracao'
  },
  {
    path: '/adm/serverStatus',
    name: ['Status do Servidor', 'Server Status'],
    view: 'Administracao'
  },
  {
    path: '/adm/valoresEPromocoes',
    name: ['Valores e Promocoes', 'Pricing and Promotions'],
    view: 'Administracao'
  },
  {
    path: '/instrucoes',
    name: ['Instruções', 'Instructions'],
    view: 'Static',
    free: true
  },
  {
    path: '/apresentacao',
    name: ['Apresentação', 'Introduction'],
    view: 'Static',
    free: true
  },
  {
    path: '/colaborar',
    name: ['Como Colaborar', 'How to contribute'],
    view: 'Static',
    free: true
  },
  {
    path: '/autores',
    name: ['Autores e citação', 'Authors and citation'],
    view: 'Static',
    free: true
  },
  {
    path: '/livrobr',
    name: ['BR-Corte 2010 (Português)', 'BR-Corte 2010 (Portuguese)'],
    view: 'Static',
    free: true
  },
  {
    path: '/livroen',
    name: ['BR-Corte 2010 (Inglês)', 'BR-Corte 2010 (English)'],
    view: 'Static',
    free: true
  },
  {
    path: '/livro2016br',
    name: ['BR-Corte 2016 (Português)', 'BR-Corte 2016 (Portuguese)'],
    view: 'Static',
    free: true
  },
  {
    path: '/livro2016en',
    name: ['BR-Corte 2016 (Inglês)', 'BR-Corte 2016 (English)'],
    view: 'Static',
    free: true
  },
  {
    path: '/livro2023br',
    name: ['BR-Corte 2023 (Português)', 'BR-Corte 2023 (Portuguese)'],
    view: 'Static',
    free: true
  },
  {
    path: '/livro2023en',
    name: ['BR-Corte 2023 (Inglês)', 'BR-Corte 2023 (English)'],
    view: 'Static',
    free: true
  },
  {
    path: '/politica-privacidade',
    name: ['Política de Privacidade', 'Privacy Policy'],
    view: 'Static',
    free: true
  },
  {
    path: '/termos-uso',
    name: ['Termos de Uso', 'Terms of Service'],
    view: 'Static',
    free: true
  },

  {
    path: '*',
    name: ['404', '404'],
    view: 'NotFoundPage',
    free: true
  }
]
